import { fetchProductPricingInfo } from "../api/rest/products";
import { useQuery } from "react-query";

export const useFetchProductPricingInfo = (productId: number) =>
  useQuery(["productVariantPricingInfo", productId], () =>
    fetchProductPricingInfo(productId)
  );
